"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FundDetailRequest = void 0;
var FundDetailRequest = /** @class */ (function () {
    function FundDetailRequest() {
    }
    return FundDetailRequest;
}());
exports.FundDetailRequest = FundDetailRequest;
;
//# sourceMappingURL=fundDetail.request.js.map